var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-480ac1de\",\"scoped\":false,\"hasInlineConfig\":false}!./node_modules/vue-loader/lib/selector?type=styles&index=0!./app.vue")
}
var Component = require("!./node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./node_modules/vue-loader/lib/selector?type=script&index=0!./app.vue"),
  /* template */
  require("!!./node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-480ac1de\",\"hasScoped\":false}!./node_modules/vue-loader/lib/selector?type=template&index=0!./app.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/Users/evox/Repos/vue-antiscroll-addon/example/app.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] app.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-480ac1de", Component.options)
  } else {
    hotAPI.reload("data-v-480ac1de", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app.vue
// module id = 38
// module chunks = 0